import { Container, Divider, SkeletonText } from '@chakra-ui/react';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import CompanyHeader from 'features/companies/components/CompanyHeader';
import { useResource } from 'hooks/useResource';
import { useParams, useSearchParams } from 'react-router-dom';
import FormEditList from '../components/forms/FormEditList';

export default function PageEditList() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { isFetched, data: list } = useResource({
    id,
    resourceName: 'list',
    path: 'lists',
  });
  const isLoaded = isFetched && !!list;

  return (
    <>
      <HeaderBarInternal
        title="Editar Lista"
        backTo={`/listas-de-disparo${searchParams.size > 0 ? `?${searchParams}` : ''}`}
      >
        <CompanyHeader company={list?.company} />
      </HeaderBarInternal>

      <Divider />

      <Container variant="internal" flexDirection="column">
        <SkeletonText isLoaded={isLoaded}>
          {list && <FormEditList list={list} />}
        </SkeletonText>
      </Container>
    </>
  );
}
